import numeral from 'numeral';

export const decimalFormatter = value => numeral(value).format('(0,0.00)');
export const decimalWithSignFormatter = value => value ? numeral(value).format('0.00') : null;
